<template>
    <v-container
      class="fill-height"
      fluid
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="4"
        >
          <h3 class="display-2 text-center white--text text-uppercase font-weight-black main--title">Mr Pool</h3>
          <h4 class="display-1 text-center white--text text-uppercase font-weight-bold small-title secondary--title">Secure Access</h4>
          <v-card class="elevation-0" color="rgba(32, 87, 85, 0)">
            <v-toolbar
              color="rgba(43, 132, 132, 0)"
              dark
              flat
            >
              <v-spacer></v-spacer>
              <v-toolbar-title class="display-1 text-uppercase font-weight-black sub--title">Enter Pin</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text class="fieldbg">
              <v-form class="mt-2 mb-2">
                <CodeInput :loading="false" class="input verification-input" v-on:change="onChange" v-on:complete="onComplete" :fields="fields" />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn x-large min-width="200" light color="#ffffff" class="mb-4 access-btn" @click.prevent="submit" :loading="loading">Access</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>


<script>
    import { mapActions } from 'vuex'
    import CodeInput from "vue-verification-code-input"
    import TokenService from '../services/storage.service'

    export default {
        props: {
        source: String,
        },
        data: () => ({
            form: {
                email: '',
                code: ''
            },
            fields: 4,
            loading: false
        }),
        components: {
            CodeInput
        },
        mounted() {
          this.$store.commit('menu/SET_TRANSITION', false)
          this.form.email = TokenService.getUser()
        },
        methods: {
            ...mapActions({
              signIn: 'auth/signCode'
            }),
            submit() {
              this.loading = true
              this.signIn(this.form).then(() => {
                  this.$router.replace({
                    name: 'Dashboard'
                  })
              }).catch(() => {
                this.loading = false
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Login Failed! Please try again.')
              })
            },
            onComplete(v) {
              this.form.code = v

              this.submit()
            }
        }
    }
</script>

<style lang="sass">
.Code
    background: url('~@/assets/matrix.jpg')!important
    background-size: cover

    &:before 
        content: ""
        width: 100%
        height: 100%
        position: fixed
        background: rgba(0, 9, 9, 0.75)
        top: 0
        left: 0

.react-code-input-container
    margin: 0 auto

.react-code-input-container 
  .react-code-input > input
    border: 1px solid #3b8f8e!important
    font-family: Roboto!important
    font-size: 20px!important
    font-weight: 900!important
    color: #fff!important
    border-right: none!important

.react-code-input-container 
  .react-code-input 
    > input
      &:last-child
        border-right: 1px solid #3b8f8e!important

.fieldbg
  background: rgba(32, 87, 85, 0.5)
  max-width: 274px
  margin: 0 auto 10px

.v-application 
  .display-2.main--title 
    font-size: 61px!important
    line-height: 1em
    font-family: 'Pyxel'!important

h4
  &.display-1
    &.text-center
      &.white--text
        &.font-weight-bold
          &.small-title 
            font-size: 32px!important
            line-height: 1em
            margin-bottom: 60px!important
            font-family: 'Pyxel'!important
            margin-bottom: 15px

.v-card__text
  &.fieldbg
    border-radius: 10px!important
    margin-bottom: 10px

button
  &.mb-4
    &.v-btn
      &.v-btn--contained
        &.theme--light
          &.v-size--x-large
            &.access-btn 
              font-size: 30px
              color: #174240
              width: 274px
              font-family: 'Pyxel'!important
              letter-spacing: 0!important

.v-toolbar__title
  &.display-1
    &.text-uppercase
      &.font-weight-black
        &.sub--title 
          font-size: 54px!important
          line-height: 1em!important
          letter-spacing: 0!important
          font-family: 'Pyxel'!important
          margin-bottom: 15px!important
</style>